/* eslint-disable no-param-reassign */
import { useRouter } from 'vue-router';
import Icon from '@teacher/config/menu-icon';

export function generatePathMap() {
  const pathMap = {};
  const router = useRouter();
  const list = router.getRoutes();
  list.forEach((r) => {
    if (r.meta.menuCode) {
      pathMap[r.meta.menuCode] = r.path;
    }
  });
  return pathMap;
}

const map = new Map();
// 处理menu树,添加path,并得到每个path对应的menu对象
export function menuTransfer(menus, pathMap) {
  const menuCodeList = [];

  function recursive(root) {
    const path = pathMap[root.menuCode];
    if (path) {
      root.path = path;
      map.set(path, root);
    }

    if (root.menuCode) {
      menuCodeList.push(root.menuCode);
    }
    if (Icon[root.menuName]) {
      root.icon = Icon[root.menuName];
    }
    // eslint-disable-next-line no-unused-expressions
    root.childMenuVos?.forEach((menu) => {
      recursive(menu);
      menu.parent = root;
    });
  }
  menus.forEach((menu) => recursive(menu));
  return [menus, menuCodeList];
}

// 给定path,得到菜单路径
export function getMenuFlat(path) {
  let obj = map.get(path);
  const roads = [];
  if (obj) {
    roads.push(obj);
    while (obj.parent) {
      obj = obj.parent;
      roads.unshift(obj);
    }
  }
  return roads;
}
